<div class="modal-container">
  <h1 i18n>Password protection</h1>
  <h3 i18n>Enter a new password for this template.</h3>
  <input name="password" id="password" type="text" [formControl]="passwordInput" placeholder="Enter your password here" i18n-placeholder />
  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="clear-input" (click)="submit$.next(null)" i18n>Clear password</button>
    <button class="submit-button" (click)="submit$.next(passwordInput.value)" i18n>Submit</button>
  </section>
</div>
